export default {"src":"/_next/static/media/gno.909f6ab4.svg","height":32,"width":32,"blurWidth":0,"blurHeight":0};